import React, { FC, memo, useState } from 'react';
import { User } from '@shared/interfaces/user';
import { useStyles } from './CurrentUserMenu.styles';
import { RockyAvatar } from '@shared/components/RockyAvatar';
import classNames from 'classnames';
import { IconButton, Menu, MenuItem, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LogoutIcon from '@mui/icons-material/Logout';
import { signOutCustom } from '@shared/helpers/auth';

interface Props {
  user: User;
  isTabletMenuOpen?: boolean;
}

const CurrentUserMenuComponent: FC<Props> = ({ user, isTabletMenuOpen }) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const avatarSrc =
    user.imageUrl ||
    `https://eu.ui-avatars.com/api/?background=ffd9a3&color=000&name=${user.name.split(' ').join('+')}`;

  return (
    <div className={styles.root}>
      <RockyAvatar medium imageUrl={avatarSrc} fullName={user.name || ''} />
      <div className={classNames(styles.userInfoContainer, { [styles.shown]: isTabletMenuOpen })}>
        <p className={styles.name}>{user.name}</p>
        <p className={styles.role}>{user.position}</p>
      </div>

      <IconButton size="small" onClick={handleOpen} aria-label="more">
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem onClick={signOutCustom}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Log out
        </MenuItem>
      </Menu>
    </div>
  );
};

export const CurrentUserMenu = memo(CurrentUserMenuComponent);
